export default "__VITE_ASSET__CT8cZl6K__"